module.exports = "https://img.zhijierongxing.com/saas/img/menu3.c7a7468b.png";